import { useEffect, useRef } from 'react';

import { IRestaurant } from '@rbi-ctg/store';
import useEffectOnce from 'hooks/use-effect-once';
import { EventName, emitEvent } from 'utils/event-hub';

const useStoreLocatorPerformanceEvents = (stores: IRestaurant[], variation: string) => {
  const hasSeenStores = useRef(false);

  useEffectOnce(() => {
    // Start when the user lands on this page
    emitEvent(EventName.STORE_LOCATOR_INITIAL_RESULTS_START);
  });

  useEffect(() => {
    // Stop when the user first sees stores
    if (!hasSeenStores.current && stores.length) {
      hasSeenStores.current = true;
      emitEvent(EventName.STORE_LOCATOR_INITIAL_RESULTS_END, { variation });
    }
  }, [stores]);
};

export default useStoreLocatorPerformanceEvents;
